import api from "@/api";

export interface SeoAbout {
  title?: string;
  text?: string;
  link?: string;
}

/**
 * Busca o conteúdo "Sobre o Bella" do rodapé cadastrado no admin (tabela config).
 * O rodapé usa o retorno como fonte primária e mantém os textos estáticos de
 * `tradutors/mainfooter.ts` como fallback por campo (`||`). Campos em branco
 * são omitidos pela API, então caem no estático naturalmente.
 */
export async function useSeoAbout(language: string) {
  const key = `seo-about-${language}`;
  const asyncData = useAsyncData(key, async () => {
    try {
      const res = await api.get("v1/seo/about", {
        params: { language },
      });
      return (res.data?.about as SeoAbout) ?? null;
    } catch {
      return null;
    }
  });

  await asyncData; // bloqueia o SSR até o fetch resolver (data.value populado)

  return asyncData.data; // Ref<SeoAbout | null>
}
